import React, { createContext, useContext, useState } from 'react';
import { toast } from 'sonner';

const CouponContext = createContext(null);

// Mock coupon database - in production, validate via API
const VALID_COUPONS = {
  'WELCOME10': { discount: 10, minPurchase: 0, description: '10% off for new customers' },
  'SAVE20': { discount: 20, minPurchase: 50, description: '20% off orders over €50' },
  'NATURAL25': { discount: 25, minPurchase: 100, description: '25% off orders over €100' },
  'FREESHIP': { discount: 0, freeShipping: true, minPurchase: 0, description: 'Free shipping on any order' }
};

export const CouponProvider = ({ children }) => {
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  const applyCoupon = (code, cartTotal) => {
    const coupon = VALID_COUPONS[code.toUpperCase()];
    
    if (!coupon) {
      toast.error('Invalid coupon code');
      return false;
    }

    if (cartTotal < coupon.minPurchase) {
      toast.error(`Minimum purchase of $${coupon.minPurchase} required`);
      return false;
    }

    setAppliedCoupon({ code: code.toUpperCase(), ...coupon });
    toast.success(`Coupon applied: ${coupon.description}`);
    return true;
  };

  const removeCoupon = () => {
    setAppliedCoupon(null);
    toast.info('Coupon removed');
  };

  const calculateDiscount = (cartTotal) => {
    if (!appliedCoupon || !appliedCoupon.discount) return 0;
    return (cartTotal * appliedCoupon.discount) / 100;
  };

  return (
    <CouponContext.Provider value={{
      appliedCoupon,
      applyCoupon,
      removeCoupon,
      calculateDiscount,
      hasFreeShipping: appliedCoupon?.freeShipping || false
    }}>
      {children}
    </CouponContext.Provider>
  );
};

export const useCoupon = () => {
  const context = useContext(CouponContext);
  if (!context) {
    throw new Error('useCoupon must be used within CouponProvider');
  }
  return context;
};